import defineMessages from "../../../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    newSystem: {
        id: "tasks.barSorting.newSystem",
    },
});

export default messages;
